export default __webpack_public_path__ + "static/media/main_section8.075a5093.jpg";